import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './dossier-invoice.action';

@Injectable({ providedIn: 'root' })
export class DossierInvoicesTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                amount: '',
                paid_to: null,
                datetime_of_payment: '',
                notes: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    statuses = [
        {id: "1", name:"DOSSIER_INVOICE.queued"},
        {id: "2", name:"DOSSIER_INVOICE.sent"},
        {id: "3", name:"DOSSIER_INVOICE.failed"},
        {id: "4", name:"DOSSIER_INVOICE.failed-permanently"}
    ];

    paid_tos = [
        {id: "1", name:"DOSSIER_INVOICE.nikki"},
        {id: "2", name:"DOSSIER_INVOICE.club"},
        {id: "3", name:"DOSSIER_INVOICE.third-party"}
    ];

    hasFilter = false;
    dossierId: string;
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'amount', name: 'DOSSIER_INVOICE.amount', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'paid_to', name: 'DOSSIER_INVOICE.paid-to', sortable: true, hasFilter: true, filter: "select", options: 'paid_tos', options_id: "id", options_label: "name"},
                { prop: 'datetime_of_payment', name: 'DOSSIER_INVOICE.payment-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'notes', name: 'DOSSIER_INVOICE.notes', sortable: true, hasFilter: true, filter: "input"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({id: this.dossierId}));
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '',
            amount: '',
            paid_to: null,
            datetime_of_payment: '',
            notes: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}